// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"ph-z","itemsContainer":"qh-z"};